import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { log } from '@ntap/core';
import { Subscription } from 'rxjs';
import { EarhivUiComponents } from '..';

@Component({
  selector: 'app-main-hierarchylistview',
  templateUrl: './main-hierarchylistview.component.html',
  styleUrls: ['./main-hierarchylistview.component.scss']
})
export class MainHierarchylistviewComponent implements OnInit, OnDestroy {
  INIT_COMP_ID = EarhivUiComponents.TREELISTVIEW;
  currentViewName: string;
  currentViewState: object | null = null;
  currentViewStateFilter: object = {};
  currentViewClass: string;

  routeChangeSubscription: Subscription;

  constructor(protected route: ActivatedRoute) {}

  ngOnInit() {
    this.subscribeToRouteChange();
  }

  ngOnDestroy(): void {
    this.unsubscribeFromRouteChange();
  }

  subscribeToRouteChange() {
    log('subscribe to route params');
    this.routeChangeSubscription = this.route.paramMap.subscribe(
      (paramsMap) => {
        const strViewName = paramsMap.get('viewName');
        if (strViewName) {
          log('param change');
          this.changeView(strViewName);
        }
      }
    );
  }

  unsubscribeFromRouteChange(): any {
    log('Unsubsubscribe from route params');
    if (this.routeChangeSubscription) {
      this.routeChangeSubscription.unsubscribe();
    }
  }

  changeView(viewName: string) {
    log(`CHANGE NEW view: ${viewName}`);
    this.currentViewName = viewName;
    this.currentViewState = {};
    this.currentViewStateFilter = {};
    this.currentViewClass = 'list-view-' + viewName;
  }
}
